import { render, staticRenderFns } from "./PageRecos.vue?vue&type=template&id=0d251e28"
import script from "./PageRecos.vue?vue&type=script&lang=js"
export * from "./PageRecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports